module.exports = __webpack_public_path__ + "static/media/56.66120c18.png";